// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"268":"76112556ed368d42","647":"fec46ade8fb1e897"}[chunkId] + ".js";
};